import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const getToken = () => localStorage.getItem("efa_token");
export const setToken = (t) =>
  t ? localStorage.setItem("efa_token", t) : localStorage.removeItem("efa_token");

const api = axios.create({ baseURL: API_BASE, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const resolveImg = (v) =>
  !v ? null : String(v).startsWith("http") ? v : `${API_BASE}/files/${v}`;

export const streamUrl = (lessonId) =>
  `${API_BASE}/lessons/${lessonId}/stream?token=${encodeURIComponent(getToken() || "")}`;

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
